import { LOCAL_STORAGE_LOCALE_KEY } from '@constants'
import { checkIsServer } from './checkIsServer'

export const setLocaleToLocalStorage = (locale: string) => {
  if (checkIsServer()) {
    return
  }

  localStorage.setItem(LOCAL_STORAGE_LOCALE_KEY, locale)
}
